import $ from 'jquery';
import init from '../init.js';

// import {getWidth, onResize} from "../utils/window";

function showMore(e) {
  e.preventDefault();

  const _THIS = $(this);
  const page = _THIS.attr('data-next-url');

  // more container
  const PARENT = _THIS.parent();

  const CARDS = _THIS.parent().parent();
  const GRID = CARDS.find('> .articles-list');

  PARENT.addClass('-loading');

  $.get(page, '', function (r) {
    PARENT.remove();
    CARDS.find('.cards-error').remove();

    const ITEMS = $(r).find('.articles-list > .articles-item');
    const NEW_BTN = $(r).find('.cards > .more');

    if (ITEMS.length) {
      GRID.append(ITEMS);
    }

    if (NEW_BTN.length) {
      CARDS.append(NEW_BTN);
    }

    init(ITEMS);

    NEW_BTN.find('#show').on('click', showMore);
  });
}

function query() {
  const mainCategory = $('.news-category-btn.is-selected');
  const baseUrl = mainCategory.attr('href');

  const sectors = $('.news-filter-btn[data-sector].is-selected');
  const types = $('.news-filter-btn[data-tag].is-selected');

  const hasSectors = sectors.length > 0;
  const hasTypes = types.length > 0;

  const entriesContainer = $('.news-entries');
  const cardContainer = entriesContainer.find('.cards');

  let mainUrl = baseUrl + '/';
  let sectorStr = '';
  let typesStr = '';

  if (hasSectors) {
    sectors.each((index, el) => {
      sectorStr = addToString(sectorStr, 'data-sector', index, $(el));
    });
  }

  if (hasTypes) {
    types.each((index, el) => {
      typesStr = addToString(typesStr, 'data-tag', index, $(el));
    });
  }

  if (hasSectors) {
    mainUrl += ('query/' + sectorStr);

    if (hasTypes) {
      mainUrl += ('/' + typesStr);
    }
  } else {
    if (hasTypes) {
      mainUrl += ('type/' + typesStr);
    }
  }

  cardContainer.find('.articles-list').css('display', 'none');
  cardContainer.find('.more').addClass('-loading');

  $.get(mainUrl, '', function (r) {
    const _cards = $(r).find('.cards');
    const _articles = $(r).find('.cards .articles-item');

    if (_cards.length > 0) {
      cardContainer.remove();
      setTimeout(() => {

        if (_articles.length === 0) {
          _cards.find('.cards-error').css('display', 'block');
        }

        entriesContainer.append(_cards);
        init(entriesContainer);

        const SHOW_MORE = $('#content.news .cards .more #show');
        SHOW_MORE.on('click', showMore);
      }, 500);
    }
  });
}

function addToString(str, attr, index, el) {
  let buildStr = str;
  if (index === 0) {
    buildStr = el.attr(attr);
  } else {
    buildStr += `,${el.attr(attr)}`;
  }

  return buildStr;
}

function initialise() {
  // for the load more section
  const SHOW_MORE = $('#content.news .cards .more #show');
  SHOW_MORE.on('click', showMore);

  const cats = $('.news-category-btn');
  const buttons = $('.news-filter-btn');

  if (cats.length > 0 && buttons.length > 0) {
    cats.click(function (e) {
      e.preventDefault();

      const _this = $(this);

      if (!_this.hasClass('is-selected')) {
        cats.removeClass('is-selected');
        $(this).addClass('is-selected');

        query();
      }
    });

    buttons.click(function (e) {
      $(this).toggleClass('is-selected');

      query();
    });
  }
}

export default function newsPage() {
  // const $html = $('html');
  // const $scroller = $('html, body');

  $(function () {
    if ($('.news').length) {
      initialise();
    }
  });
}



// WEBPACK FOOTER //
// ./source/scripts/pages/news.js